import React from "react";
import { Typography } from "@material-ui/core";
import { get } from "lodash";
import { useMemo } from "react";

const createDelegatedDoc = (record, translate, type) =>
  get(record, `${type}.representative`) === "delegated"
    ? {
        ...get(record, `${type}.delegated_doc.file`),
        sub: translate(
          `resources.research-projects.fields.${type}.delegated_doc`
        ),
      }
    : null;

const useDocs = (record, translate) =>
  useMemo(
    () =>
      get(record, "docs", [])
        .map((doc) => ({
          name: get(doc, "media.file.name"),
          path: get(doc, "media.file.path"),
          type: get(doc, "research_project_doc_type_id"),
          sub:
            get(doc, "protocol_code", null) !== null ? (
              <Typography variant="caption">
                {get(doc, "protocol_code")}
                <br />
                {get(doc, "research_project_doc_type.name")}
              </Typography>
            ) : // I documenti di tipo "Corrispondenza PEC (2)" non devono riportare
            // la tipologia nel sub poiché non serve in fase di visualizzazione.
            get(doc, "research_project_doc_type_id") === 2 ? null : (
              get(doc, "research_project_doc_type.name")
            ),
        }))
        .concat(
          [
            createDelegatedDoc(record, translate, "company"),
            createDelegatedDoc(record, translate, "partner"),
          ].filter((item) => item !== null)
        ),
    [record, translate]
  );

export default useDocs;
